import React from 'react'
import { ViewMode } from '../../types'

interface ViewToggleProps {
  currentView: ViewMode
  onViewChange: (view: ViewMode) => void
  className?: string
}

const ViewToggle: React.FC<ViewToggleProps> = ({
  currentView,
  onViewChange,
  className = ''
}) => {
  return (
    <div className={`inline-flex bg-secondary-100 rounded-lg p-1 ${className}`}>
      <button
        onClick={() => onViewChange('today')}
        className={`
          px-3 py-1.5 text-sm font-medium rounded-md transition-all duration-200
          ${currentView === 'today'
            ? 'bg-white text-primary-600 shadow-sm'
            : 'text-secondary-600 hover:text-secondary-800'
          }
        `}
      >
        今日
      </button>
      <button
        onClick={() => onViewChange('week')}
        className={`
          px-3 py-1.5 text-sm font-medium rounded-md transition-all duration-200
          ${currentView === 'week'
            ? 'bg-white text-primary-600 shadow-sm'
            : 'text-secondary-600 hover:text-secondary-800'
          }
        `}
      >
        7天
      </button>
    </div>
  )
}

export default ViewToggle
